//
import type { IPolicyPolicyData } from '@/shared/api/models.bff';
import { type IAddress } from './Address';

export interface IOwner {
  firstName: string;
  lastName: string;
  name: string;
  dob: string;
  email: string;
  ssn: string;
  address: IAddress;
}

export const mapOwnerResponse = (policyData: IPolicyPolicyData): IOwner => {
  const mappedOwner = {
    firstName: policyData.ownerFirstName,
    lastName: policyData.ownerLastName,
    name:
      policyData.ownerFirstName && policyData.ownerLastName
        ? `${policyData.ownerFirstName} ${policyData.ownerLastName}`
        : '',
    dob: policyData.ownerDOB,
    ssn: policyData.ownerSSN,
    address: {
      address1: policyData.ownerAddress?.address1 ?? '',
      address2: policyData.ownerAddress?.address2 ?? '',
      city: policyData.ownerAddress?.city ?? '',
      state: policyData.ownerAddress?.state ?? '',
      zip: policyData.ownerAddress?.zip ?? '',
      phone: policyData.phoneNumber ?? '',
    },
    email: policyData.clientEmailaddress,
  };
  return mappedOwner;
};
